import {createAction} from 'redux-actions';
import * as Constants from './constants';
import * as ComplainConstants from './../constants';

export const updateComplaintSellerSuccess = createAction(Constants.UPDATE_COMPLAINT_SELLER_SUCCESS.REQUEST, (filters) => (filters));
export const clearErrorComplaintSellerSuccess = createAction(Constants.CLEAR_ERROR_COMPLAINT_SELLER_SUCCESS, () => ({}));
export const closeModalChangeSuccess = createAction(ComplainConstants.CLOSE_MODAL_CHANGE_COMPLAINT_SUCCESS, () => ({}));